//2018-03-06

'use strict';

window.tagManagerHelper =
{
	productClick:function(productThumb, event)
	{	//2018-03-06
		event = event || window.event;
		const clickTarget = event.target || event.srcElement;
		
		if((clickTarget.nodeName === 'BUTTON' && clickTarget.classList.contains('addToCart')) || typeof(window.google_tag_manager) === 'undefined') return true;
		
		const newTabOrWindow = !!(event.metaKey || event.ctrlKey || event.shiftKey);		//⌘ = new tab (macos), ^ = new tab (windows), ⇧ = new window
		
		const dataAttribute = productThumb.getAttribute('data-data-layer-data') || productThumb.getAttribute('data-gtm-data');
		
		const productData = JSON.parse(dataAttribute);
		
		const productURL = productThumb.querySelector('a[href]').href;
		
		productData.position = [...productThumb.parentNode.children].indexOf(productThumb);
		
		window.dataLayer.push
		({
			'event':'productClick',
			'ecommerce':
			{
				'click':
				{
					//'actionField': {'list': 'Search Results'},      // Optional list property.
					'products':[productData]
				}
			},
			'eventCallback':function()
			{
				if(!newTabOrWindow) document.location = productURL;
			}
		});
		
		return newTabOrWindow;
	}
};

window.gtmHelper = window.tagManagerHelper;		//alias
